import axiosPrivate from "./axiosPrivate"

export const getFacebookPages = async () => {
   return await axiosPrivate.get(`me/accounts`, {
      params: {
         fields: "name,id,access_token",
         limit: 100
      },
   })
}
